import { render, staticRenderFns } from "./AvatarTraffic.vue?vue&type=template&id=19c0fc46"
import script from "./AvatarTraffic.vue?vue&type=script&lang=js"
export * from "./AvatarTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports